import axios from "axios";
import { BASE_URL } from "../../variables";

export const getUserFeedbackApi = async () => {
  const options = {
    url: `${BASE_URL}/services/data/v56.0/query?q=select id,User_Name_es__c,createdDate from Capture_Insight__c where RecordType.Name ='My User' Order By CreatedDate desc`,
    method: "get",
  };

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.[0].message;
    if (errors) {
      return { error: error?.response?.data?.[0].message };
    } else if (error?.code === "ERR_NETWORK") {
      return { error: error?.code };
    } else {
      return { error: "Something went wrong" };
    }
  }
};
